import { Button, Container, Grid, TextField } from "@mui/material";
import { ArrowBack, Check } from "@mui/icons-material";
import * as queryString from "query-string";
import React, { useEffect, useState } from "react";
import MultiSelect from "react-multi-select-component";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserGroupbyID, getPoolList, updatePoolUserGroup, setPoolUserGroup, isUpdateTask, resetIsUpdateTask } from "../../store/actions/userGroupActions";
import { handleBackendMessage, renderToaster } from "../../common";
import CustomList from "../../components/List/CustomList";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";

export default function AddUserGroupToPool() {
    const dispatch = useDispatch();
    const res = useSelector(({ UserGroup }) => UserGroup);
    let [data, setData] = useState({
        groupCode: "",
        groupName: "",
    });
    let [allGroup, setAllGroup] = useState([]);
    let [selectedNames, setSelectedNames] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const { t } = useTranslation("translation");
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        LoadHandler();
    }, []);

    useEffect(() => {
        setSelectedNames(Object.values(selected).map((item) => {return item.name}))
    }, [selected]);

    useEffect(() => {
        if (res.userGroup) {
            const obj = res.userGroup.length > 0 ? res.userGroup[0] : undefined;

            if (obj !== undefined) {
                const selectedResult = obj.poolsOfGroup.map((item, index) => ({
                    label: item.name,
                    value: item.id,
                    name:item.name
                }));
                setSelected(selectedResult);

                for (let key in obj) {
                    setData((state) => ({ ...state, [key]: obj[key] }));
                }
            }

            setPageLoaded(true);

            // if (res.userGroup?.errorCode === 1) {
            //     GeneralCatchError({ data: { message: res.userGroup?.message } });
            // }
        }
        if (res.userPoolGroup) {
            if (res.userPoolGroup?.errorCode === 0) {
                setAllGroup(
                    Object.values(res.userPoolGroup?.resultObject).map((item, index) => ({
                        label: item.name,
                        value: item.id,
                        name:item.name
                    }))
                );
            }
            // if (res.userPoolGroup?.errorCode === 1) {
            //     GeneralCatchError({ data: { message: res.userPoolGroup?.message } });
            // }
        }
        if (res.userupdatedPoolGroup !== undefined) {
            if (res.userupdatedPoolGroup?.errorCode === 0) {
                // GeneralCatchSuccess({ data: { message: res.userupdatedPoolGroup?.message } });
                LoadHandler();
            }
            // if (res.userupdatedPoolGroup?.errorCode === 1) {
            //     GeneralCatchError({ data: { message: res.userupdatedPoolGroup?.message } });
            // }
            dispatch(setPoolUserGroup(undefined));
        }
    }, [res]);



    useEffect(() => {
        if (res?.isTaskUpdatedUserGroup) {
            LoadHandler();
        }
    }, [res.isTaskUpdatedUserGroup]);

    const LoadHandler = () => {
        dispatch(getUserGroupbyID(queryString.parse(window.location.search).id));
        dispatch(getPoolList());
    };

    //add data
    const AddHandler = () => {
        const data = selected.map((item) => item.value);
        dispatch(updatePoolUserGroup({ id: queryString.parse(window.location.search).id, data: data }));
        dispatch(isUpdateTask);
        dispatch(resetIsUpdateTask);
    };

    const history = useHistory();
    const TurnBack = () => {
        history.push({ pathname: "/usergroups/" });
    };

    //override strings in multiselect
    const stringTR = {
        selectSomeItems: t("SelectSomeItems"),
        allItemsAreSelected: t("AllItemsAreSelected"),
        selectAll: t("SelectAll"),
        search: t("Search"),
    };

    return (
        <Container id="augtp_Container" maxWidth="md">
            <h1>{t("UserGroupInformation")}</h1>
            {pageLoaded === true ? (
                <Grid id="augtp_Grid" container spacing={3}>
                    <Grid id="augtp_Grid_1" item xs={12} sm={6} md={6}>
                        <TextField
                            id="augtp_TextField"
                            label={t("UserGroupCode")}
                            value={data.groupCode}
                            defaultValue={data.groupCode}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid id="augtp_Grid_2" item xs={12} sm={6} md={6}>
                        <TextField
                            id="augtp_TextField_1"
                            label={t("UserGroupName")}
                            value={data.groupName}
                            defaultValue={data.groupName}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid id="augtp_Grid_3" item xs={6} sm={6}>
                        <h4>{t("Pools")}</h4>
                        <Autocomplete
                            multiple
                            id="augtp_Autocomplete_1"
                            options={allGroup}
                            limitTags={5}
                            value={allGroup.filter((item) => selectedNames.includes(item.name))}
                            disableCloseOnSelect={true}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} margin="normal" label={t("Pool")} variant="outlined" id="augtp_table_TextField_0" />}
                            onChange={(event, newValue) => {
                                setSelected(newValue)
                            }}
                            renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
                            size={"normal"}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <pre style={{ marginTop: 25 }}>
                            <CustomList id="augtp_cl" dense={true} listItems={selected} name="list1"/>
                        </pre>
                    </Grid>
                    <Grid item xs={6} sm={6} style={{ textAlign: "left" }}>
                        <Button
                            id="augtp_Button"
                            onClick={TurnBack}
                            variant="contained"
                            endIcon={<ArrowBack />}
                            style={{ marginRight: 15 }}>
                            {t("TurnBack")}
                        </Button>
                        <Button id="augtp_Button_1" onClick={() => AddHandler()} variant="contained" color="primary" endIcon={<Check />}>
                            {t("Save")}
                        </Button>
                    </Grid>
                </Grid>
            ) : null}
            <LoadingBackdrop id="augtp_lbd" />
        </Container>
    );
}
